// TODO download modules ///////////////////////////////////////////////////////////////////////////////////////////////
import React from "react";
import { Link } from "react-router-dom";
// TODO custom modules /////////////////////////////////////////////////////////////////////////////////////////////////
import * as components from "../../js/components";
import * as utils from "../../js/utils";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
// TODO default export const page //////////////////////////////////////////////////////////////////////////////////////
export const RationalTemplatePage = () => {
  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div className="m-0 p-0">
      <components.HeaderComponent />
      <main>
        <ul className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 justify-content-center text-center shadow m-0 p-1">
          <div className="card shadow custom-background-transparent-low m-0 p-0">
            <div className="card-header bg-warning bg-opacity-10 m-0 p-3">
              <h6 className="lead fw-bold m-0 p-0">
                Тренажёр виртуальной реальности
              </h6>
            </div>
            <div className="card-body m-0 p-0">
              <div className="d-flex justify-content-between m-0 p-0">
                <label className="form-control-sm text-center m-0 p-1">
                  Подразделение:
                  <select
                    className="form-control form-control-sm text-center m-0 p-1"
                    required
                  >
                    <option className="m-0 p-0" value="">
                      энергоуправление
                    </option>
                  </select>
                </label>
                <label className="form-control-sm text-center m-0 p-1">
                  Зарегистрировано за №{" "}
                  <strong className="btn btn-light disabled">
                    000-01-03-2020
                  </strong>
                </label>
              </div>
              <div className="m-0 p-0">
                <label className="form-control-sm text-center m-0 p-1">
                  Категория:
                  <select
                    className="form-control form-control-sm text-center m-0 p-1"
                    required
                  >
                    <option className="m-0 p-0" value="">
                      инновации
                    </option>
                  </select>
                </label>
              </div>
              <div className="m-0 p-0">
                <img
                  src={utils.GetStaticFile(
                    "/media/default/rational/template_rational.jpg"
                  )}
                  className="img-fluid img-thumbnail w-75 m-1 p-0"
                  alt="изображение отсутствует"
                />
              </div>
              <div className="m-0 p-0">
                <label className="form-control-sm text-center w-50 m-0 p-1">
                  Место изменения:
                  <input
                    type="text"
                    className="form-control form-control-sm text-center m-0 p-1"
                    defaultValue="Учебный центр АО 'Костанайские Минералы'"
                    readOnly={true}
                    placeholder="введите место изменения тут..."
                    required
                    minLength="1"
                    maxLength="300"
                  />
                </label>
              </div>
              <div className="m-0 p-0">
                <label className="w-100 form-control-sm m-0 p-1">
                  Проблема:
                  <textarea
                    className="form-control form-control-sm text-center m-0 p-1"
                    defaultValue="Предлагаю разработать симулятор виртуальной реальности для обучения персонала особо опасным действиям в условиях, приближенных к реальности."
                    readOnly={true}
                    placeholder="введите в это поле - 'какую проблему Вы хотите решить?'"
                    minLength="1"
                    maxLength="3000"
                    rows="3"
                  />
                  <small className="text-danger m-0 p-0">
                    * обязательно
                    <small className="text-muted m-0 p-0">
                      {" "}
                      * длина: не более 3000 символов
                    </small>
                  </small>
                </label>
              </div>
              <div className="m-0 p-0">
                <label className="w-100 form-control-sm m-0 p-1">
                  Решение:
                  <textarea
                    className="form-control form-control-sm text-center m-0 p-1"
                    defaultValue="Предлагаю разработать симулятор виртуальной реальности для обучения персонала особо опасным действиям в условиях, приближенных к реальности."
                    readOnly={true}
                    placeholder="введите в это поле - 'какое решение Вы предлагаете?'"
                    minLength="1"
                    maxLength="3000"
                    rows="3"
                  />
                  <small className="text-danger m-0 p-0">
                    * обязательно
                    <small className="text-muted m-0 p-0">
                      {" "}
                      * длина: не более 3000 символов
                    </small>
                  </small>
                </label>
              </div>
              <div className="m-0 p-0">
                <label className="w-100 form-control-sm m-0 p-1">
                  Эффект:
                  <textarea
                    className="form-control form-control-sm text-center m-0 p-1"
                    defaultValue="Предлагаю разработать симулятор виртуальной реальности для обучения персонала особо опасным действиям в условиях, приближенных к реальности."
                    readOnly={true}
                    placeholder="введите в это поле - 'какого эффекта Вы планируете достичь?'"
                    minLength="1"
                    maxLength="3000"
                    rows="3"
                  />
                  <small className="text-danger m-0 p-0">
                    * обязательно
                    <small className="text-muted m-0 p-0">
                      {" "}
                      * длина: не более 3000 символов
                    </small>
                  </small>
                </label>
              </div>
              <div className="m-0 p-0">
                <label className="form-control-sm text-center m-0 p-1">
                  Отчёт о внедрении:
                  <a
                    className="btn btn-sm btn-primary w-75 m-0 p-1"
                    href={utils.GetStaticFile(
                      `/media/default/rational/тренажёр.docx`
                    )}
                  >
                    Скачать отчёт
                  </a>
                </label>
              </div>
              <div className="m-0 p-0">
                <label className="form-control-sm text-center m-0 p-1">
                  Вложение № 1:
                  <a
                    className="btn btn-sm btn-primary w-75 m-0 p-1"
                    href={utils.GetStaticFile(
                      `/media/default/rational/тренажёр.txt`
                    )}
                  >
                    Скачать
                  </a>
                </label>
              </div>
              <div className="m-0 p-0">
                <label className="form-control-sm text-center m-0 p-1">
                  Вложение № 2:
                  <a
                    className="btn btn-sm btn-primary w-75 m-0 p-1"
                    href={utils.GetStaticFile(
                      `/media/default/rational/тренажёр.pdf`
                    )}
                  >
                    Скачать
                  </a>
                </label>
              </div>
              <div className="m-0 p-0">
                <label className="form-control-sm text-center m-0 p-1">
                  Вложение № 3:
                  <a
                    className="btn btn-sm btn-primary w-75 m-0 p-1"
                    href={utils.GetStaticFile(
                      `/media/default/rational/тренажёр.xlsx`
                    )}
                  >
                    Скачать
                  </a>
                </label>
              </div>
              <div className="m-0 p-0">
                <Link to="#" className="btn btn-sm btn-warning m-0 p-2">
                  Автор: Андриенко Богдан Техник-программист
                </Link>
              </div>
              <div className="m-0 p-0">
                <label className="w-100 form-control-sm m-0 p-1">
                  Участники:
                  <input
                    type="text"
                    className="form-control form-control-sm text-center m-0 p-1"
                    defaultValue="Иванов Иван Иванович 931778 70%"
                    readOnly={true}
                    placeholder="участник № 1"
                    minLength="0"
                    maxLength="300"
                  />
                  <input
                    type="text"
                    className="form-control form-control-sm text-center m-0 p-1"
                    defaultValue="Иванов Иван Николаевич 931779 30%"
                    readOnly={true}
                    placeholder="участник № 2"
                    minLength="0"
                    maxLength="300"
                  />
                </label>
              </div>
              <div className="d-flex justify-content-between m-0 p-1">
                <label className="text-muted border m-0 p-2">
                  подано: <p className="m-0">15-02-2021 11:00</p>
                </label>
                <label className="text-muted border m-1 p-2">
                  зарегистрировано: <p className="m-0 p-0">16-02-2021 14:00</p>
                </label>
              </div>
            </div>
            <div className="card-footer m-0 p-1">
              <div className="d-flex justify-content-between m-0 p-1">
                <span className="text-success m-0 p-1">Рейтинг</span>
                <Navbar className="text-center m-0 p-0">
                  <Container className="m-0 p-0">
                    <Nav className="me-auto dropdown m-0 p-0">
                      <NavDropdown
                        title="10 /  1"
                        className="btn btn-sm bg-success bg-opacity-50 badge rounded-pill"
                      >
                        <ul className="m-0 p-0">
                          <li className="list-group-item bg-success bg-opacity-10">
                            <small className="">Андриенко Богдан : 10</small>
                          </li>
                        </ul>
                      </NavDropdown>
                    </Nav>
                  </Container>
                </Navbar>
                <span className="m-0 p-1">
                  <i
                    style={{
                      color: "#00ff00",
                    }}
                    className="fas fa-star m-0 p-0"
                  />
                  <i
                    style={{
                      color: "#00ff00",
                    }}
                    className="fas fa-star m-0 p-0"
                  />
                  <i
                    style={{
                      color: "#00ff00",
                    }}
                    className="fas fa-star m-0 p-0"
                  />
                  <i
                    style={{
                      color: "#00ff00",
                    }}
                    className="fas fa-star m-0 p-0"
                  />
                  <i
                    style={{
                      color: "#00ff00",
                    }}
                    className="fas fa-star m-0 p-0"
                  />
                  <i
                    style={{
                      color: "#00ff00",
                    }}
                    className="fas fa-star m-0 p-0"
                  />
                  <i
                    style={{
                      color: "#00ff00",
                    }}
                    className="fas fa-star m-0 p-0"
                  />
                  <i
                    style={{
                      color: "#00ff00",
                    }}
                    className="fas fa-star m-0 p-0"
                  />
                  <i
                    style={{
                      color: "#00ff00",
                    }}
                    className="fas fa-star m-0 p-0"
                  />
                  <i
                    style={{
                      color: "#00ff00",
                    }}
                    className="fas fa-star m-0 p-0"
                  />
                </span>
              </div>
              <div className="d-flex justify-content-between m-0 p-1">
                <span className="text-secondary m-0 p-1">Комментарии</span>
                <span className="badge bg-secondary rounded-pill m-0 p-2">
                  1
                </span>
              </div>
            </div>
            <div className="card-footer m-0 p-0">
              <ul className="list-group m-0 p-0">
                <li className="list-group-item m-0 p-1">
                  <div className="d-flex justify-content-between m-0 p-1">
                    <h6 className="m-0 p-0">Андриенко Богдан</h6>
                    <span className="text-muted m-0 p-0">17-02-2021 15:00</span>
                  </div>
                  <div className="d-flex justify-content-center m-0 p-1">
                    <small className="text-muted m-0 p-1">
                      Это очень полезное рационализаторское предложение!
                    </small>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </ul>
      </main>
      <components.FooterComponent />
    </div>
  );
};
